import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmailTemplatesPage from "@/pages/admin/EmailTemplatesPage";

export const Route = createFileRoute("/_admin/admin/email-templates")({
  head: () => pageHead("Admin · Email Templates", "AKIVA admin · email templates portal.", "/admin/email-templates", true),
  component: EmailTemplatesPage,
});
